import axios from 'axios';

import 'bootstrap';
import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  initialize() {
    this.url = this.data.get('url');
  }

  show(event) {
    const self = this;

    event.preventDefault();

    axios.get(this.url).then((response) => {
      self.constructor.renderModal(response.data);
    });
  }

  static renderModal(content) {
    if ($('#modal-remote').length === 0) {
      $('body').append('<div id="modal-remote">');
    }

    $('#modal-remote')[0].innerHTML = content;
    $('#modal-remote').find('.modal').modal('show');

    window.ReactRailsUJS.mountComponents('#modal-remote');
  }
}
